import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { PartnerVat } from "../../model/domain/partner-vats/partner-vat";
import { IPartnerVatsRestService } from "./partner-vats-rest";
import { VatCountry } from "@modules/user/model/domain/partner-vats/vat-country";
import { Vat } from "@modules/user/model/domain/partner-vats/vat";


export class PartnerVatsRestService extends AbstractAccessorService<PartnerVat> implements IPartnerVatsRestService {

    public readonly $name: string = "partnerVatsRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<PartnerVat>) {
        super();
    }
    public saveVats(vats:Array<Vat>): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean,Array<Vat>,string>(this.$name, "saveVats",{
            data: vats
        })
    }

    public getCountries(): angular.IPromise<IResponse<Array<VatCountry>>> {
        return this.$accessor<Array<VatCountry>, string>(this.$name, "getCountries")
    }
}